import React from 'react'
import { useSelector } from 'react-redux'

import { getReservationById } from 'app/fieldapp/store/reservations/selectors'
import { ApplicationState } from 'app/fieldapp/store/store'
import { getUnitById } from 'app/fieldapp/store/units/selectors'

import { VisitResDetails } from './VisitResDetails'

export type VisitResDetailsContainerProps = {
  unitId: string
}

export const VisitResDetailsContainer: React.FC<VisitResDetailsContainerProps> =
  React.memo(({ unitId }) => {
    const unit = useSelector((state: ApplicationState) =>
      getUnitById(state, unitId),
    )

    const currentRes = useSelector((state: ApplicationState) =>
      getReservationById(state, unit?.currentResId || ''),
    )

    const nextRes = useSelector((state: ApplicationState) =>
      getReservationById(state, unit?.nextResId || ''),
    )

    const previousRes = useSelector((state: ApplicationState) =>
      getReservationById(state, unit?.previousResId || ''),
    )

    return (
      <VisitResDetails
        currentRes={currentRes}
        previousRes={previousRes}
        nextRes={nextRes}
      />
    )
  })
